/**
 * Singapura — Active-Exempt-unaudited AGM chatflow (CSI003). title → 회사 선택 → confirm.
 *   steps/handleEvent 는 형제 aura agm 플로우 재사용. id·taskCode·환영문만 별도.
 */
import type { ConversationMessage } from '@/features/AI-documents/types/docGen.types';
import type { ChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/types';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import { auraAgmFlow } from '../../aura/agm/chatflows/auraAgmFlow';

export const singapuraAgmFlow: ChatFlow = {
  ...auraAgmFlow,
  id: 'singapura-agm',
  taskCodeMatch: ['CSI003'],
  categoryMatch: ['active exempt', 'unaudited', 'annual general meeting', 'agm'],

  getInitialMessages(_preSet: PreSetSelection): ConversationMessage[] {
    return [
      {
        role: 'ai',
        content:
          `Welcome to **Singapura — Active-Exempt-unaudited AGM Documents**.\n\n` +
          `This preset prepares the full AGM set for a small (audit-exempt) company: Directors' Resolutions in Writing, ` +
          `Notice of AGM, Agreement to Shorter Notice, Minutes, and Attendance Sheet.\n\n` +
          `Directors sign the resolutions/notice, members sign the agreement/attendance, and the chairman signs the minutes — ` +
          `all filled from the selected company.\n\n` +
          `First, enter a **Task Title**, then select the **company**.`,
        timestamp: Date.now(),
        stepId: 1,
        source: 'system',
      },
    ];
  },
};
